import { 
  Share2, 
  CheckCircle2, 
  Globe, 
  MessageSquareText
} from 'lucide-react';
import { ElementType } from 'react';

export interface Feature {
  id: string;
  title: string;
  description: string;
  icon: ElementType;
  isComingSoon?: boolean;
}

export const activeFeatures: Feature[] = [
  {
    id: 'share',
    title: 'Share Anywhere',
    description: 'Share instantly using WhatsApp, Email, SMS or a simple link.',
    icon: Share2,
  },
  {
    id: 'rsvp',
    title: 'Smart RSVP',
    description: 'Collect guest responses in real time.',
    icon: CheckCircle2,
  },
  {
    id: 'website',
    title: 'Personal Invitation Website',
    description: 'Every invitation gets its own beautiful hosted website.',
    icon: Globe,
  },
  {
    id: 'wish-wall',
    title: 'Guest Wish Wall',
    description: 'Allow guests to leave personalized messages and wishes.',
    icon: MessageSquareText,
  }
];

export const upcomingFeatures: Feature[] = [];

export const allFeatures = [...activeFeatures, ...upcomingFeatures];
